import { render, staticRenderFns } from "./AuthorisationEditor.vue?vue&type=template&id=6c5ac31a&"
import script from "./AuthorisationEditor.vue?vue&type=script&lang=js&"
export * from "./AuthorisationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports